import React, { FC } from 'react';
import { cn } from '../../../helpers';

type SystemNotificationContentProps = React.HTMLAttributes<HTMLElement>;

export const SystemNotificationContent: FC<SystemNotificationContentProps> = ({
    children,
    className,
    ...props
}): JSX.Element => {
    return (
        <div className={cn('d-flex col-10 col-sm-9', className)} style={{ gap: '0.5rem' }} {...props}>
            {children}
        </div>
    );
};
